import { cn } from '@/lib/utils'

function PageTemplate() {
  return null
}

interface PageTemplateHeaderProps extends ComponentProps {
  hasBreadcrumb?: boolean
}

PageTemplate.Header = function PageTemplateHeader({
  className,
  children,
  hasBreadcrumb = false,
}: PageTemplateHeaderProps) {
  return (
    <section
      className={cn('flex shrink-0 items-center gap-2', hasBreadcrumb ? 'pt-2' : 'pt-6', className)}
    >
      {children}
    </section>
  )
}

PageTemplate.H1 = function PageTemplateH1({
  className,
  children,
  variant = 'default',
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { variant?: 'header' | 'default' }) {
  return (
    <h1
      className={cn(
        variant === 'default' && 'text-[32px] font-bold leading-10',
        variant === 'header' && 'max-w-lg truncate whitespace-nowrap font-normal',
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  )
}

PageTemplate.H2 = function PageTemplateH2({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2 className={cn('font-neue-machina text-2xl font-bold tracking-wide', className)} {...props}>
      {children}
    </h2>
  )
}

PageTemplate.H3 = function PageTemplateH3({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3 className={cn('text-2xl font-normal tracking-wide', className)} {...props}>
      {children}
    </h3>
  )
}

PageTemplate.H4 = function PageTemplateH4({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h4 className={cn('font-normal tracking-wide text-neutral-500', className)} {...props}>
      {children}
    </h4>
  )
}

export { PageTemplate }
